export const getKey = (field, resource) => `resources.${resource}.fields.${field}`;
